import { render, staticRenderFns } from "./DatosContacto.vue?vue&type=template&id=378685b4&scoped=true&"
import script from "./DatosContacto.vue?vue&type=script&lang=js&"
export * from "./DatosContacto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378685b4",
  null
  
)

export default component.exports